import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthLayout } from '@/layouts/AuthLayout';
import { locations } from '@/locations';
import { ChangePasswordPage, LoginPage, PasswordChangedPage, ResetLinkSentPage, ResetPasswordPage } from '@/pages/auth';
import { NoMatchPage } from '@/pages/NoMatchPage';
import { CodeVerificationPage } from '@/pages/auth/CodeVerificationPage';
import { MethodVerificationPage } from '@/pages/auth/MethodVerificationPage';
import { AssetsPreviewPage, SettingsPage, SitesPage } from '@/pages';
import { AssetStudioPage } from '@/pages/AssetStudioPage';
import { AppWrapper } from '@/AppWrapper';

export const AppRouter = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path={locations.public.login} element={<LoginPage />} />
      <Route path={locations.public.resetPassword} element={<ResetPasswordPage />} />
      <Route path={locations.public.sent} element={<ResetLinkSentPage />} />
      <Route path={locations.public.change} element={<ChangePasswordPage />} />
      <Route path={locations.public.changed} element={<PasswordChangedPage />} />
      <Route path={locations.public.secondFactorMethod} element={<MethodVerificationPage />} />
      <Route path={locations.public.secondFactorVerification} element={<CodeVerificationPage />} />
    </Route>

    {/* @TODO: Move routes to a closed list */}
    <Route path={locations.base} element={<AppWrapper />}>
      <Route index element={<Navigate to={locations.protected.sites.index} />} />
      <Route path="sites" element={<SitesPage />} />
      <Route path={'/sites/:siteId/machines'} element={<AssetsPreviewPage />} />
      <Route path={'/sites/:siteId/machines/:id/components'} element={<AssetStudioPage />} />
      <Route path={'/settings/*'} element={<SettingsPage />} />
    </Route>

    <Route path={locations.fallback} element={<NoMatchPage />} />
  </Routes>
);
